import { FieldDatePicker } from 'components/redesign/FieldDatePicker';
import { FieldInput } from 'components/redesign/FieldInput';
import { FC } from 'react';
import { Step1Props } from './types';
import { FieldTextarea } from 'components/redesign/FieldTextArea';
import { ModerationRequestStatusId } from 'enums/moderationRequestStatus';
import { mapExecutorChecklistField } from '../finalStep/consts';
import { isFieldDisabled } from '../../consts';

export const Step1Fields: FC<Step1Props> = ({
  control,
  isFormDisabled,
  errors,
  clearErrors,
  parentId,
  moderationRequestData,
  checkFieldInChecklist,
}) => {
  return (
    <div className="flex flex-col gap-8 sm:grid sm:grid-cols-[minmax(0,600px)_minmax(0,600px)]">
      <FieldTextarea
        name="lastName"
        control={control}
        label="Фамилия"
        isClearable
        errorMessage={errors?.lastName?.message}
        maxLength={200}
        clearErrors={clearErrors}
        disabled={isFieldDisabled(
          mapExecutorChecklistField.FullName,
          isFormDisabled,
          moderationRequestData,
          checkFieldInChecklist
        )}
      />
      <FieldTextarea
        name="firstName"
        control={control}
        label="Имя"
        isClearable
        disabled={isFieldDisabled(
          mapExecutorChecklistField.FullName,
          isFormDisabled,
          moderationRequestData,
          checkFieldInChecklist
        )}
        errorMessage={errors?.firstName?.message}
        maxLength={200}
        clearErrors={clearErrors}
      />
      <FieldTextarea
        name="middleName"
        control={control}
        label="Отчество"
        isClearable
        disabled={isFieldDisabled(
          mapExecutorChecklistField.FullName,
          isFormDisabled,
          moderationRequestData,
          checkFieldInChecklist
        )}
        errorMessage={errors?.middleName?.message}
        maxLength={200}
        clearErrors={clearErrors}
      />
      <FieldDatePicker
        name="birthDate"
        control={control}
        label="Дата рождения"
        disabled={isFieldDisabled(
          mapExecutorChecklistField.BirthDate,
          isFormDisabled,
          moderationRequestData,
          checkFieldInChecklist
        )}
        errorMessage={errors?.birthDate?.message}
        maxDate={new Date()}
        clearErrors={clearErrors}
      />
      <FieldInput
        name="inn"
        control={control}
        label="ИНН"
        isClearable
        disabled={
          moderationRequestData?.status === ModerationRequestStatusId.ElaborationRequested
            ? checkFieldInChecklist &&
              checkFieldInChecklist(moderationRequestData, mapExecutorChecklistField.Inn)
            : isFormDisabled || Boolean(parentId)
        }
        errorMessage={errors?.inn?.message}
        mask="999999999999"
        clearErrors={clearErrors}
      />
      <FieldInput
        name="snils"
        control={control}
        label="СНИЛС"
        isClearable
        disabled={
          moderationRequestData?.status === ModerationRequestStatusId.ElaborationRequested
            ? checkFieldInChecklist &&
              checkFieldInChecklist(moderationRequestData, mapExecutorChecklistField.Snils)
            : isFormDisabled
        }
        errorMessage={errors?.snils?.message}
        mask="999-999-999 99"
        clearErrors={clearErrors}
      />
    </div>
  );
};
